import React, { useContext, useEffect, useState } from "react";
import InnerLayout from "../../components/layouts/inner-layout";
import { DataContext } from "../../components/layouts/main-layout";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import LoadingSpinner from "../../components/helper-components/loading-spinner";
import errorToast from "../../components/helper-components/error-toast";
import { selfDeclarationViewAction } from "../../redux/actions/store-action";
import AccessDenied from "../../components/helper-components/access-denied";
import SelfDeclarationView from "../../components/store-information/self-declaration/self-declaration-view";

const ViewSelfDeclaration = () => {
  const { permissionFn } = useContext(DataContext);
  // Same access check as Price List: the page needs "read" on
  // self_declaration and shows AccessDenied without it.
  const hasAccess = permissionFn("self_declaration")?.read === true;
  const dispatch = useDispatch();
  const { id } = useParams();
  const [declaration, setDeclaration] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!hasAccess) return;
    dispatch(selfDeclarationViewAction(id, onSuccess, onError));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, hasAccess]);

  const onSuccess = (data) => {
    const record = data?.data ?? {};
    setDeclaration(record);
    setLoading(false);
  };
  const onError = (data) => {
    setLoading(false);
    errorToast(data?.message ?? data?.data?.message ?? "Failed to load self declaration");
  };

  if (!hasAccess) {
    return (
      <InnerLayout title="View Self Declaration" backBtn={true}>
        <AccessDenied message="You don't have permission to view Self Declaration." />
      </InnerLayout>
    );
  }

  return (
    <>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <InnerLayout
          backBtn={true}
          page="view"
          title={"View Self Declaration"}
          title1={declaration?.franchisee_name}
        >
          <SelfDeclarationView
            declaration={declaration}
            permissionFn={permissionFn}
          />
        </InnerLayout>
      )}
    </>
  );
};

export default ViewSelfDeclaration;
